const mountedNavigationScenes = new WeakSet();

export function refreshNavigationScene(scene) {
  const width = scene.getBoundingClientRect().width;
  const fullWidth = !!scene.closest('[data-ptt-full-width-scene]');
  const composition = width < 600 ? 'mobile' : width < (fullWidth ? 1200 : 900) ? 'compact' : 'desktop';
  scene.dataset.pttComposition = composition;
  const ratioKey = `pttRatio${composition[0].toUpperCase()}${composition.slice(1)}`;
  const ratio = Number(scene.dataset[ratioKey]);
  if (Number.isFinite(ratio) && ratio > 0) scene.parentElement.style.aspectRatio = String(ratio);
  scene.querySelectorAll('[data-ptt-navigation-environment]').forEach((source) => {
    source.media = source.dataset.pttNavigationEnvironment === composition ? 'all' : 'not all';
    source.sizes = `${Math.ceil(width)}px`;
  });
  const background = scene.querySelector('.ptt-navigation-scene__background');
  if (background) background.sizes = `${Math.ceil(width)}px`;
  scene.querySelectorAll('.ptt-shoppable-product__image').forEach((image) => {
    const layer = image.closest('.ptt-navigation-scene__product');
    const crop = image.closest('.ptt-shoppable-cutout');
    const source = image.closest('foreignObject');
    const naturalWidth = Number(source?.getAttribute('width')) || Number(image.getAttribute('width')) || 1;
    const cropWidth = crop ? crop.viewBox.baseVal.width : naturalWidth;
    const paintedWidth = crop ? crop.getBoundingClientRect().width : layer.getBoundingClientRect().width;
    image.sizes = `${Math.ceil(paintedWidth * naturalWidth / cropWidth)}px`;
  });
}

export function mountNavigationScenes(root = document) {
  root.querySelectorAll('[data-ptt-navigation-scene]').forEach((scene) => {
    if (mountedNavigationScenes.has(scene)) return;
    mountedNavigationScenes.add(scene);
    refreshNavigationScene(scene);
    const observer = new ResizeObserver(() => refreshNavigationScene(scene));
    observer.observe(scene);
    scene.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
  });
}

mountNavigationScenes();
document.addEventListener('shopify:section:load', (event) => mountNavigationScenes(event.target));
